'use client';
import { QuestionProjection } from '@lib/sanity/queries/modules/faq/types';
import { useState } from 'react';
import Item from './item';

type Props = {
  items?: (QuestionProjection & { key: number })[];
  className: string;
};
export default function ItemContainer({ items, className }: Props) {
  const [openKey, setOpenKey] = useState<number | undefined>();
  function renderContainer(faq: QuestionProjection & { key: number }) {
    return (
      <Item
        className={className}
        question={faq.question}
        answer={faq.answer}
        answerRich={faq.answerRich}
        key={faq.key}
        isOpen={openKey === faq.key}
        setOnClick={() => (openKey === faq.key ? setOpenKey(undefined) : setOpenKey(faq.key))}
      ></Item>
    );
  }

  return items?.map(renderContainer);
}
